import { alertController } from '@ionic/vue';

export const simpleAlert = async(title: string, subTitle?: string, message?: string) => {
  const alert = await alertController.create({
    header: title,
    subHeader: subTitle,
    message: message,
    buttons: ['Ok'],

  });

  await alert.present();
};
